// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","main-image":"Header_main-image__i6znb"};